<!-- <section class="content d-flex"> -->
<div class="content-block">
  <div class="d-flex align-items-center justify-content-between gap-3 flex-wrap" style="padding-bottom: 24px;">
    <h5 class="mb-0">Job Scheduling</h5>
    <div class="d-flex align-items-center gap-3">
      <div class="conflict-b d-box" (click)="onConflicts()">
        <i class="fas fa-info text-white"></i>
        <div class="dot"></div>
      </div>

      <button *ngIf="isAdmin" type="button" class="btn  btn-outline-primary "
        routerLink="/iframe/iframe-job-request">Requests</button>
      <button *ngIf="!isAdmin" type="button" class="btn  btn-outline-primary "
        routerLink="/rec/job-request">Requests</button>

      <button mat-raised-button color="primary" class="new-btn" (click)="onSettings()">
        <i class="material-icons me-2 ">settings</i>Settings
      </button>
    </div>
  </div>
  <div class="calendar-container">
    <div class="calendar-new-header">
      <div class="d-flex flex-wrap justify-content-between gp-tb-15">
        <div class="d-flex gp-tb-15 flex-wrap">
          <div class="view-cont me-3">
            <div class="view-b " (click)="onViewByClick()">
              <div>View Options</div>
              <div>
                <img src="assets/images/icons/down_arrow.svg" class="img-fluid" alt=""
                  [ngClass]="{ 'up-arr' :isViewByClick}">
              </div>
            </div>
            <div class="view-box" *ngIf="isViewByClick" [appOutsideClick]="isViewByClick" @fadeAnimation
              (outSideClick)="isViewByClick = false">
              <!--Below are the different types of the view user can filter for that one array is being used in ts file -->
              <div *ngIf="viewMode != 'month'">
                <div *ngFor="let item of viewByArr">
                  <div class="d-flex align-items-center justify-content-between m-box" *ngIf="isValidViewMode(item)">
                    <div class="v-i" (click)="onViewTypeChange(item.value)">
                      <img [src]="item.img" class="img-fluid me-3" alt="">
                      <div class="v-c">View by {{item.name}}</div>
                    </div>
                    <i class="material-icons green-tick" *ngIf="viewBy==item.value">done</i>
                  </div>
                </div>
              </div>
              <div class="v-i pt-2 m-box" (click)="onViewTypeChange('list')">
                <img src="assets/images/icons/list_icon.svg" class="img-fluid me-3" alt="">
                <div class="v-c">List View</div>
              </div>
              <div *ngIf="viewMode == 'week' ">
                <div class="d-flex align-items-center week-item pt-2">
                  <div class="flex-grow-1 text-medium"> Weekly Totals </div>
                  <div>
                    <mat-slide-toggle color="primary" class="mb-0 slide-1" (change)="onWeeklyTotal($event)"
                      [checked]="isWeeklyTotals"></mat-slide-toggle>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1 text-medium"> Daily Totals </div>
                  <div>
                    <mat-slide-toggle color="primary" class="mb-0 slide-1" (change)="onDailyTotal($event)"
                      [checked]="isDailyTotals"></mat-slide-toggle>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center week-item pt-2">
                <div class="flex-grow-1 text-medium"> Availability Status </div>
                <div>
                  <mat-slide-toggle color="primary" class="mb-0 slide-1" (change)="onAvaliStatus($event)"
                    [checked]="isShowAvailStatus"></mat-slide-toggle>
                </div>
              </div>
            </div>
          </div>

          <div class="view-cont me-3">
            <div class="view-b add-b" (click)="onAddOption()">
              <div>Add</div>
              <div>
                <img src="assets/images/icons/down_arrow.svg" class="img-fluid" alt=""
                  [ngClass]="{ 'up-arr' :isAddOption}">
              </div>
            </div>
            <div class="view-box add-option" *ngIf="isAddOption" [appOutsideClick]="isAddOption" @fadeAnimation
              (outSideClick)="isAddOption = false">
              <div class="v-i pt-2 m-box" (click)="onAddSelection(item.value)" *ngFor="let item of addArr">
                <div class="v-c">{{item.name}}</div>
              </div>
              <div class="v-i pt-2 m-box border-t" (click)="onAddUnavailability()">
                <div class="v-c">Add Unavailability</div>
              </div>
            </div>
          </div>
          <div class="view-cont me-3">
            <div class="view-b action-b" (click)="onActionClick()">
              <div>Actions</div>
              <div>
                <img src="assets/images/icons/down_arrow.svg" class="img-fluid" alt=""
                  [ngClass]="{ 'up-arr' :isActionClick}">
              </div>
            </div>
            <div class="view-box add-option" *ngIf="isActionClick" [appOutsideClick]="isActionClick" @fadeAnimation
              (outSideClick)="isActionClick = false">
              <div class="v-i pt-2 m-box" (click)="onActionSelection(item)" *ngFor="let item of getActionItems()">
                <div class="v-c">{{item.name}}</div>
              </div>
            </div>
          </div>
          <div class="search-cont w-auto">
            <div class="s-item d-box " (click)="onFilterView()">
              <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
            </div>
          </div>
        </div>
        <div class="d-flex flex-wrap gp-tb-15">
          <div class="me-3">
            <mat-select class="form-control cal-view" [(ngModel)]="viewMode" (selectionChange)="toggleView($event)">
              <mat-option value="month">Month</mat-option>
              <mat-option value="week">Week</mat-option>
              <mat-option value="day">Day</mat-option>
            </mat-select>
          </div>
          <div class="month-box me-3" id="monh">
            <i class="material-icons cursor-pointer" (click)="prev()">navigate_before</i>
            <div>
              <span *ngIf="viewMode === 'month'">{{ currentMonth | date: 'MMMM yyyy' }}</span>
              <span *ngIf="viewMode === 'week'">{{weekHeader}}</span>
              <span *ngIf="viewMode === 'day'" (click)="picker.open()">{{ daysInDay.fDate | dates }} </span>
              <mat-datepicker #picker></mat-datepicker>
              <input matInput [matDatepicker]="picker" style="visibility: hidden;width: 0px;"
                (dateChange)="onDateChange($event)" [value]="currentDate">
            </div>
            <i class="material-icons cursor-pointer" (click)="next()">navigate_next</i>
          </div>
          <div class="today-box d-box me-3" (click)="onTodayClick()" [matTooltip]="'Go to current '+ viewMode">
            <img src="assets/images/icons/today_calendar.svg" class="img-fluid" alt="">
          </div>
          <!-- <button mat-raised-button color="primary" class="new-btn">Publish</button> -->
        </div>
      </div>
    </div>
    <!-- Filter  -->
    <app-filter *ngIf="isFilterShow" [fieldCol]="filterArr" (childEvent)="callApi($event)"></app-filter>
    <!-- Filter end -->
    <div *ngIf="viewMode === 'month'" class="calendar-grid mt-4" cdkDropListGroup>
      <div class="calendar-day-header" *ngFor="let day of daysOfWeek"> {{ day }} </div>
      <div class="calendar-day" *ngFor="let day of daysInMonth"
        [ngClass]="{'faded': !day.isCurrentMonth,'today':day.isToday}" [attr.dt]="day.date" cdkDropList
        [cdkDropListData]="day.events" (cdkDropListDropped)="dropEvent($event, day)">
        <div class="day-number" (click)="onDateClick(day)">{{ getDayLabel(day.date) }}</div>
        <!-- unavailability is shown for the month view and week view please make changes for all the views if any changes made here. -->
        <!-- <div *ngIf="day.unav.length > 0 && isShowAvailStatus">
          <div class="event job-item unavl clamp-line-1" (click)="onViewUnavailability()">
            {{unavailabilityArr.length}} Unavailable
          </div>
        </div> -->
        <div *ngIf="day.unav.length > 0 && isShowAvailStatus">
          <div class="event job-item unavl clamp-line-1" (click)="onViewUnavailability(day)">
            {{day.unav.length}} Unavailable
          </div>
        </div>
        <div class="events">
          <ng-container *ngFor="let event of day.events; let i = index">
            <!-- if open shift then don't allow to drag and drop it. -->
            <!-- [cdkDragDisabled]="event.op_s" -->
            <div class="event job-item" *ngIf="(i < 4 || day.expanded) && event.op_n != 0 " cdkDrag [cdkDragData]="event"
              (cdkDragStarted)="dragStarted($event)" (mouseover)="onHover($event, i,event)"
              [cdkDragDisabled]="event.op_s==1 " (mouseout)="onHoverOut()" cdkDragBoundary=".calendar-grid"
              (click)="onAddShift('edit',event,day)" [ngClass]="getShiftColor(event)">
              <span *ngIf="event.op_s" class="d-flex align-items-center">
                <span class="qty qty-m me-1">{{event.qty-event.used}}</span>
                <i class="material-icons me-1 rpt-icon" style="font-size: 16px;" matTooltip="Repeating Shift"
                  *ngIf="event.repeat">repeat</i>
                Open Shift
                <!-- <span *ngIf="userType=='recruiter'">{{event.company_name}}</span> -->
              </span>
              <span *ngIf="!event.op_s">
                <span *ngIf="!event.all_day" class="d-flex"> {{getTrimmedTime(event.st_ti)}} -
                  {{getTrimmedTime(event.ed_ti)}}
                  <i class="material-icons ms-1 rpt-icon" style="font-size:12px;"
                    matTooltip="Repeating Shift">repeat</i>
                </span>
                <div *ngIf="event.all_day">
                  <i class="material-icons me-1 rpt-icon" style="font-size:12px;"
                    matTooltip="Repeating Shift">repeat</i> All day
                </div>
                <span class="clamp-line-1 pt-1">{{event.first_name}} {{event.last_name}}</span>
                <span class="clamp-line-1 pt-1">{{event.j_sc}}</span>
              </span>
              <div class="event job-item" *cdkDragPreview style="max-width: 130px;" [ngClass]="getShiftColor(event)">
                <span *ngIf="!event.all_day"> {{getTrimmedTime(event.st_ti)}} - {{getTrimmedTime(event.ed_ti)}}
                  <i class="material-icons ms-1 rpt-icon" style="font-size:12px;"
                    matTooltip="Repeating Shift">repeat</i>
                </span>
                <div *ngIf="event.all_day">
                  <i class="material-icons me-1 rpt-icon" style="font-size:12px;"
                    matTooltip="Repeating Shift">repeat</i> All day
                </div>
                {{getTrimmedTitle(event.first_name) }}
              </div>
            </div>
          </ng-container>
          <div *ngIf="day.events.length > 4 && !day.expanded" class="more-events" (click)="toggleExpand(day)">
            +{{day.events.length - 4}} more </div>
          <div *ngIf="day.expanded && day.events.length > 4" class="less-events" (click)="toggleExpand(day)"
            @fadeAnimation> Show less </div>
        </div>
        <div class="add-box m-auto" (click)="onAddShift('add','',day)" *ngIf="!isDraggingEnabled" @fadeInOut>
          <i class="material-icons">add</i>
        </div>
        <!-- <div [ngTemplateOutlet]="hoverDivTemplate"></div> -->
      </div>
    </div>
    <div *ngIf="viewMode === 'week'" class="calendar-week-view mt-4" style="max-height: 600px;overflow-y: auto;">
      <div class="d-flex week-cont">
        <div class="cal-b"></div>
        <div *ngFor="let item of daysInWeek; let i = index" (click)="onDateClick(item)"
          class="cal-b cursor-pointer week-hbox wh-b week-height" id="week-box">
          <div class="week-h">{{item.dayOfWeek}}-{{item.day}} {{item.month}}</div>
          <div class="progress-w"
            [ngClass]="item.counting.per == 0 ? 'primary' : item.counting.per == 100 ? 'green' : ''">
            <span class="dot"
              [ngClass]="item.counting.per == 0 ? 'primary' : item.counting.per == 100 ? 'green' : ''"></span>
            {{item.counting.per}}% <br> ( {{item.counting.day_w_sh}} / {{item.counting.day_t_sh}} )
          </div>
        </div>
      </div>
      <!-- Please don't change the position of cdkDropListGroup otherwise you will not be able to drag and drop in the category  -->
      <!-- this is the unassigned shift commenting for -->
      <!-- <div *ngIf="viewBy=='category'" cdkDropListGroup>
          <div *ngFor="let val of categoryArr">
            <div class="cat d-flex align-items-center">
              <div class="cat-border"></div> {{ val.name }}
            </div>
            <div *ngFor="let sval of val.sub_a; let i = index" class="d-flex">
              <div class="cal-b cat-cal-b">
                <div class="cal-item d-box" [style.background]="getColorsFromArray(i)">{{ sval.s_n }}</div>
              </div>
              <div *ngFor="let day of daysInWeek; let j = index" class="job-w " cdkDropList
                [cdkDropListData]="day.events" (cdkDropListDropped)="cdropEvent($event, day,sval)">
                <div *ngFor="let event of day.events; let k = index" class="job-box" cdkDrag [cdkDragData]="event">
                  <div *ngIf="sval.j_sc_id === event.j_sc_id" class="job-item week-job-item">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="text-medium"> {{getTrimmedTime(event.start_time)}} -
                        {{getTrimmedTime(event.end_time)}}</div>
                      <div (click)="onMoreClick($event,event)" (mouseout)="onWeekHoverOut()">
                        <i class="material-icons more-ic">more_vert</i>
                      </div>
                    </div>
                    <div class="pt-1">{{getTrimmedTitle(event.
                      ) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      <div class="d-flex flex-column w-fit" *ngIf="viewBy=='c_user'||viewBy=='c_category' || viewBy=='category'"
        cdkDropListGroup>
        <div class="d-flex align-items-center min-box" *ngIf="isMinimizedView">
          <div class="d-flex align-items-center" (click)="onMinimizeView()">
            <div class="min-v ">
              <img src="assets/images/icons/maximize.svg" class="img-fluid" alt="">
            </div>
            <div class="flex-grow-1 ps-2">{{totalUnassignedShift}} Unassigned Shifts</div>
          </div>
        </div>
        <div class="d-flex ca  overflow-visible " [@expandCollapse]="isMinimizedView ? 'collapsed' : 'expanded'">
          <div class="cal-b cat-cal-b">
            <div class="d-box"> Unassigned Shift
              <div class="min-v" (click)="onMinimizeView()">
                <img src="assets/images/icons/{{ isMinimizedView ? 'maximize' : 'minimize' }}.svg" class="img-fluid"
                  alt="">
              </div>
            </div>
          </div>
          <div *ngFor="let day of daysInWeek; let j = index" class="job-w" cdkDropList
            [ngClass]="isMinimizedView ? 'd-none':''" [cdkDropListData]="day.events"
            (cdkDropListDropped)="cdropEvent($event, day,'','')">
            <div *ngFor="let event of day.events; let k = index" class="job-box" cdkDrag [cdkDragData]="event">
              <ng-container [ngTemplateOutlet]="jobItem"
                [ngTemplateOutletContext]="{ event:event,day:day,unassign:true }"></ng-container>
              <!-- <div class="job-item week-job-item open-shift" *ngIf="event.op_s" (click)="onAddShift('edit',event,day)" 
                (mouseover)="onHover($event,'',event)" (mouseout)="onHoverOut()">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="text-medium" *ngIf="!event.all_day"> {{getTrimmedTime(event.st_ti)}} - {{getTrimmedTime(event.ed_ti)}}</div>
                    <div class="text-medium" *ngIf="event.all_day"> All day</div>
                    <div (click)="onMoreClick($event,event)" (mouseout)="onWeekHoverOut()">
                      <i class="material-icons more-ic">more_vert</i>
                    </div>
                  </div>
                  <div class="pt-1"> {{getTrimmedTitle(event.j_n) }}
                    <span class="qty qty-w ms-2" [matTooltip]="event.qty+' open spots left in this shift'">{{event.qty}}</span>
                  </div>
                </div> -->
            </div>
          </div>
        </div>
        <div *ngFor="let val of viewTypeArr; let idx = index">
          <div class="cat d-flex align-items-center">
            <div class="cat-border"></div> {{ val.name }}
            <div class="min-v ms-3" (click)="toggleExpand2(idx)">
              <img src="assets/images/icons/{{ expandedState[idx] ? 'minimize' : 'maximize' }}.svg" class="img-fluid"
                alt="">
            </div>
          </div>
          <!-- [style.maxWidth.px]="maxWeekViewWidth" -->
          <div [@expandCollapse]="expandedState[idx] ? 'expanded' : 'collapsed'">
            <div [hidden]="!expandedState[idx]">
              <div *ngFor="let sval of val.sub_a; let i = index" class="d-flex ">
                <!-- <div class="cal-b cat-cal-b" [style.maxWidth.px]="maxWeekViewWidth"> removed by ankush becuase getting issue in responsive -->
                <div class="cal-b cat-cal-b">
                  <div class="cal-item d-box" [style.background]="getColorsFromArray(i)" *ngIf="viewBy=='category'">
                    <div>{{sval.j_c}}</div>
                    ({{sval.s_n }})
                  </div>
                  <div class="cal-item d-box clamp-line-2" [style.background]="getColorsFromArray(i)"
                    *ngIf="viewBy=='c_category'">
                    <div>{{sval.j_c}}</div>
                    ({{ sval.j_sc }})
                  </div>
                  <div class="cal-item d-box" [style.background]="getColorsFromArray(i)" *ngIf="viewBy=='c_user'">
                    <div class="profile-img mb-2" [appBackgroundImg]="sval.profile_picture"></div>
                    <div>{{sval.j_c}}</div>({{ sval.name }})
                  </div>
                </div>
                <div *ngFor="let day of daysInWeek; let j = index" class="job-w te" cdkDropList
                  (mouseover)="onWeekDayHover(j)" (mouseout)="onWeekDayHoverOut(j)" [cdkDropListData]="day.events"
                  (cdkDropListDropped)="cdropEvent($event, day,sval,val)">
                  <div *ngFor="let event of day.events | filterEvents:sval:viewBy:val.name; let k = index"
                    class="job-box " cdkDrag [cdkDragData]="event">
                    <!-- <div *ngFor="let event of day.events; let k = index" class="job-box " cdkDrag [cdkDragData]="event"> -->
                    <!-- <div *ngIf="filterViewWeek(sval,event) && !event.op_s" class="job-item week-job-item" -->
                    <ng-container [ngTemplateOutlet]="jobItem"
                      [ngTemplateOutletContext]="{ event:event,day:day,unassign:false }"></ng-container>
                  </div>
                  <div class="ad-box">
                    <div class="add-box me-2" (click)="onClickViewBy('add','',day,val,sval)">
                      <i class="material-icons">add</i>
                    </div>
                    <div class="add-box" (click)="onSelectTemplate($event)">
                      <i class="material-icons">reorder</i>
                    </div>
                  </div>
                </div>
                <!-- <div [ngTemplateOutlet]="hoverDivTemplate"></div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="viewBy=='user'|| viewBy=='location'|| viewBy=='company'" cdkDropListGroup>
        <div class="d-flex align-items-center min-box" *ngIf="isMinimizedView">
          <div class="d-flex align-items-center" (click)="onMinimizeView()">
            <div class="min-v">
              <img src="assets/images/icons/maximize.svg" class="img-fluid" alt="">
            </div>
            <div class="flex-grow-1 ps-2">{{totalUnassignedShift}} Unassigned Shifts</div>
          </div>
        </div>
        <div class="d-flex ca overflow-visible" [@expandCollapse]="isMinimizedView ? 'collapsed' : 'expanded'">
          <div class="cal-b cat-cal-b">
            <div class="d-box"> Unassigned Shift
              <div class="min-v" (click)="onMinimizeView()">
                <img src="assets/images/icons/{{ isMinimizedView ? 'maximize' : 'minimize' }}.svg" class="img-fluid"
                  alt="">
              </div>
            </div>
          </div>
          <div *ngFor="let day of daysInWeek; let j = index" class="job-w" cdkDropList
            [ngClass]="isMinimizedView ? 'd-none':''" [cdkDropListData]="day.events"
            (cdkDropListDropped)="cdropEvent($event, day,'','')">
            <div *ngFor="let event of day.events; let k = index" class="job-box" cdkDrag [cdkDragData]="event">
              <ng-container [ngTemplateOutlet]="jobItem"
                [ngTemplateOutletContext]="{ event:event,day:day,unassign:true  }"></ng-container>
              <!-- <div class="job-item week-job-item open-shift" *ngIf="event.op_s" (click)="onAddShift('edit',event,day)" 
                (mouseover)="onHover($event,'',event)" (mouseout)="onHoverOut()">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="text-medium" *ngIf="!event.all_day"> {{getTrimmedTime(event.st_ti)}} - {{getTrimmedTime(event.ed_ti)}}</div>
                    <div class="text-medium" *ngIf="event.all_day"> All day</div>
                    <div (click)="onMoreClick($event,event)" (mouseout)="onWeekHoverOut()">
                      <i class="material-icons more-ic">more_vert</i>
                    </div>
                  </div>
                  <div class="pt-1"> {{getTrimmedTitle(event.j_n) }}
                    <span class="qty qty-w ms-2" [matTooltip]="event.qty+' open spots left in this shift'">{{event.qty}}</span>
                  </div>
                </div> -->
            </div>
          </div>
        </div>
        <div *ngFor="let sval of viewTypeArr; let i = index" class="d-flex">
          <div class="cal-b cat-cal-b ">
            <div class=" d-flex cal-item d-box " [style.background]="getColorsFromArray(i)">
              <div *ngIf="viewBy=='user'" class="profile-img mb-2" [appBackgroundImg]="sval.profile_picture"></div>
              <div *ngIf="viewBy=='company'" class="profile-img company-logo mb-2"
                [appBackgroundImg]="sval.profile_picture" [iType]="'company_logo'"></div>
              <div>
                <div>{{sval.j_c}}</div> ({{ sval.name }})
              </div>
            </div>
          </div>
          <div *ngFor="let day of daysInWeek; let j = index" class="job-w te" cdkDropList [cdkDropListData]="day.events"
            (cdkDropListDropped)="cdropEvent($event, day,sval,'')">
            <div *ngFor="let event of day.events | filterEvents:sval:viewBy; let k = index" class="job-box" cdkDrag
              [cdkDragData]="event">
              <ng-container [ngTemplateOutlet]="jobItem"
                [ngTemplateOutletContext]="{ event:event,day:day,unassign:false }"></ng-container>
            </div>
            <!-- unavailability is shown for the month view and week view please make changes for all the views if any changes made here. -->
            <div *ngIf="isShowAvailStatus">
              <div *ngFor="let item of day.unav">
                <div *ngIf="item.em_i==sval.em_i" class="job-item unavl">
                  <div class="text-semibold pb-2">Unvailable</div>
                  <div *ngIf="item.un_avail==1">All day</div>
                  <div *ngFor="let it of item.time">{{it.st_ti}}-{{it.ed_ti}}</div>
                </div>
              </div>
            </div>
            <div class="ad-box">
              <div class="add-box me-2" (click)="onClickViewBy('add','',day,sval,'')">
                <i class="material-icons">add</i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex daily-total" *ngIf="isDailyTotals">
        <div class="cal-b">
          <div class="primary-color p-2 pt-3" (click)="onCostCalc()">View Cost Calculator</div>
        </div>
        <div *ngFor="let item of weekCountingArr ; let i = index" class="cal-b week-hbox wh-b">
          <div class="daily-t gap-2">Shift: <span class="text-bold ">{{item.day_t_sh}}</span> </div>
          <div class="daily-t gap-2">Hours: <span class="text-bold">{{item.day_ho_sh}}</span></div>
          <div class="daily-t gap-2">Users:<span class="text-bold 2">{{item.day_w_sh}}</span></div>
          <div class="daily-t gap-2">Cost:<span class="text-bold ">{{ item.day_to_cost | number:'1.0-2' }}€</span></div>
        </div>
      </div>

    </div>
    <!-- this code works for day view -->

    <div *ngIf="viewMode === 'day'" class="flex-grow-1 pb-4">
      <!-- <div class="fixed-div"> this is day view sticky modal</div> -->
      <div class="calendar-day-view d-flex">
        <!-- <div class="shift-search-box-s"></div> -->
        <!-- have removed here overflow-x:auto property from here as otherwise the grid lines were not coming in the whole available div -->
        <div style="flex-grow:1;">
          <div class="shift-main-container" style="position:relative;max-height:550px;">
            <!-- <div class="grid-lines-c">
                <div class="shift-search-box-s"></div>
                <div>
                  <div class="grid-lines" [ngStyle]="{ 'grid-template-columns': 'repeat(25, ' + boxWidth + 'px)' }">
                    <div class="grid-box" *ngFor="let hour of dayTimeHours;let i=index"></div>
                  </div>
                </div>
              </div> -->
            <div cdkDropListGroup class="min-h-400">
              <div class="time-slots" style="position: sticky;top: 0;">
                <div class="shift-search-box-s"></div>
                <div *ngFor="let hour of dayTimeHours;let i=index" class="time-slot" [style.width.px]="boxWidth">
                  <span></span>
                </div>
              </div>

              <div class="time-slots2" style="position: sticky;top: 0;">
                <div class="shift-search-box-s border-t"></div>
                <div *ngFor="let hour of dayTimeHours;let i=index" class="time-slot2" [style.width.px]="boxWidth">
                  <span>{{ hour.time }}</span>
                </div>
              </div>

              <div class="shift-c" *ngFor="let item of viewTypeArr; let j=index;trackBy: trackByFn" cdkDropList
                [cdkDropListData]="daysInDay.events" (cdkDropListDropped)="adropEvent($event,item,j)">
                <div class="shift-search-box-s">
                  <div class="shift-item d-box" [style.background]="getColorsFromArray(j)">
                    <div class="profile-img mb-2" [appBackgroundImg]="item.img" *ngIf="viewBy=='user'"></div>
                    <div style="word-break: break-all;" [matTooltip]="item.name"> {{item.name | truncate:20}}</div>
                  </div>
                </div>
                <div class="add-box add-box-d m-auto" (click)="onClickViewBy('add','',daysInDay,item,'')"
                  *ngIf="!isDraggingEnabled" @fadeInOut>
                  <i class="material-icons">add</i>
                </div>
                <div class="shift-container" #shiftContainer>
                  <!-- <div *ngFor="let job of daysInDay.events | filterEvents:item:viewBy; let i=index" cdkDropList -->
                  <div class="shift-box" *ngFor="let job of daysInDay.events | filterEvents:item:viewBy; let i=index">
                    <!-- <div class="shift-box" *ngIf="item.e_i==job.e_i" > -->
                    <div class="job-container resizable-panel" [id]="'panel_' + i" [attr.data]="job"
                      [ngStyle]="{'margin-left': job.left, 'width.px': job.width}" style="height: auto !important;">
                      <div class="j-box" [cdkDragDisabled]="isResizing" cdkDrag [cdkDragData]="job">
                        <div class="job-box" (click)="onAddShift('edit',job,daysInDay)">
                          <div class="clamp-line-1"> {{ job.j_sc }} </div>
                          <div style="font-size: 13px;">{{job.st_ti}} - {{job.ed_ti}}</div>
                          <div *ngIf="userType == 'recruiter'" class="co-nm">({{ job.company_name }})</div>
                          <!-- <div>i:{{ job.index }}</div> -->
                        </div>
                        <div class="resize-b">
                          <div class="l-res resize-i" (touchstart)="onMouseDown2($event, job, 'left')"
                            (mousedown)="onMouseDown2($event, job, 'left')"></div>
                          <div class="r-res resize-i" (touchstart)="onMouseDown2($event, job, 'right')"
                            (mousedown)="onMouseDown2($event, job, 'right')"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="weekly-total d-flex align-items-center" *ngIf="viewMode === 'week' && isWeeklyTotals" @fadeAnimation>
      <div class="text-bold me-4">Weekly Totals</div>
      <div class="d-flex justify-content-between flex-grow-1">
        <div class="w-h">Hours <span class="text-bold">{{weekCostCountingArr.week_ho_sh}}</span></div>
        <div class="w-h">Shifts <span class="text-bold">{{weekCostCountingArr.week_t_sh}}</span></div>
        <div class="w-h">Users <span class="text-bold">{{weekCostCountingArr.week_w_sh}}</span></div>
      </div>
    </div>
  </div>
  <div class="mt-24 calendar-container">
    <div [ngTemplateOutlet]="employeeDetails"></div>
  </div>
</div>
<!-- </section> -->
<!-- <ng-template #hoverDivTemplate> -->
<div #hoverDiv class="hbox" style="display: none; position: absolute;">
  <div class="h-title text-semibold">
    {{ hoverContent.j_n }}
    <div *ngIf="hoverContent.u_t == '0'">(Freelancer)</div>
    <div *ngIf="hoverContent.u_t == '1'">(Company)</div>
    <div *ngIf="hoverContent.u_t == '2'">(Recruiter)</div>
  </div>
  <!-- if recruiter login then show the company name -->
  <div class="d-flex align-items-center justify-content-start pt-2" *ngIf="userType=='recruiter'">
    <div class="profile-img me-2">
      <img *ngIf="hoverContent.company_logo" [src]="checkUrl(hoverContent.company_logo)" alt="">
      <img *ngIf="!hoverContent.company_logo" src="assets/images/logo/logo.svg" alt="">
    </div>
    <!-- <div class="profile-img me-2" [appBackgroundImg]="imageUrl+hoverContent.company_logo" [iType]="'company_logo'">
      <img *ngIf="hoverContent.company_logo" [src]="imageUrl+hoverContent.company_logo" alt="">
    </div> -->
    <div class="h-txt"> {{hoverContent.company_name }}</div>
  </div>
  <div class="d-flex align-items-center justify-content-start pt-3">
    <div class="h-icon"><i class="material-icons">date_range</i></div>
    <div class="h-txt">{{hoverContent.st_dt | dates }}</div>
  </div>
  <div class="d-flex align-items-center justify-content-start pt-2">
    <div class="h-icon"><i class="material-icons">access_time</i></div>
    <div class="h-txt" *ngIf="!hoverContent.all_day"> {{hoverContent.st_ti }} - {{hoverContent.ed_ti }}</div>
    <div class="h-txt" *ngIf="hoverContent.all_day"> All day</div>
  </div>
  <div class="d-flex align-items-center justify-content-start pt-2" *ngIf="hoverContent.op_s">
    <div class="h-icon"><i class="material-icons">people</i></div>
    <div class="h-txt"> Quantity - {{hoverContent.qty }}</div>
  </div>
  <div class="d-flex align-items-center justify-content-start pt-2">
    <div class="h-icon"><i class="material-icons">featured_play_list</i></div>
    <div class="h-txt">{{hoverContent.j_sc}} </div>
  </div>
  <div class="d-flex align-items-center justify-content-start pt-2">
    <div class="h-icon"><i class="material-icons">location_on</i></div>
    <div class="h-txt" style="text-align: left !important;">{{hoverContent.add }}</div>
  </div>
  <div class="d-flex justify-content-start pt-2" *ngIf="hoverContent.notes">
    <div class="h-icon"><i class="material-icons">info_outline</i></div>
    <div class="h-txt text-start">
      <div>Note-</div>
      <div>{{hoverContent.notes}}
      </div>
    </div>
  </div>
</div>
<!-- </ng-template> -->
<ng-template #employeeDetails>
  <div id="detail-section">

    <!-- <div class="tab-box">
      <div class="d-flex justify-content-center align-items-center tab-item me-2" id="i-1"
        (click)="onCurrentTab('working_emp')" [ngClass]="currentTab == 'working_emp' ? 'active-tab' : ''">
        <div class="tab-txt ps-1 ps-sm-2">{{"RECRUITER.CLOCKEDINEMP" | translate}}</div>
      </div>
      <div class="d-flex justify-content-center align-items-center tab-item me-2" id="i-1"
        (click)="onCurrentTab('not_working_emp')" [ngClass]="currentTab == 'not_working_emp' ? 'active-tab' : ''">
        <div class="tab-txt ps-1 ps-sm-2">{{"RECRUITER.NOTCLOCKEDEMP" | translate}}</div>
      </div>
    </div > -->
    <div class="tab-box align-items-center gap-3 " style="flex-wrap: wrap">
      <div class="custom-tab flex-wrap">
        <div class="d-flex justify-content-center align-items-center tab-item " id="i-1"
          (click)="onCurrentTab('working_emp')" [ngClass]="currentTab == 'working_emp' ? 'active-tab' : ''">
          <div class="tab-txt white-space-nowrap">{{"RECRUITER.CLOCKEDINEMP" | translate}}</div>
        </div>
        <div class="d-flex justify-content-center align-items-center tab-item " id="i-1"
          [ngClass]="currentTab == 'not_working_emp' ? 'active-tab' : ''" (click)="onCurrentTab('not_working_emp')">
          <div class="tab-txt white-space-nowrap">{{"RECRUITER.NOTCLOCKEDEMP" | translate}}</div>
        </div>
      </div>
    </div>

    <div>
      <div *ngIf="currentTab == 'working_emp'">
        <div class="table-container flex-grow-1 ">
          <table class="" mat-table [dataSource]="dataSource" class="mat-elevation-z8"
            *ngIf="dataSource.data.length!=0">
            <ng-container matColumnDef="first_name">
              <th mat-header-cell *matHeaderCellDef>{{"RECRUITER.EMPLOYEE"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex cursor-pointer">
                  <div class="profile-img me-2 view-employee" [appBackgroundImg]="element.profile_picture"
                    (click)="onViewEmployee(element.em_i)"></div>
                  <div class="view-employee" (click)="onViewEmployee(element.em_i)">
                    <div class="main-head">{{element.first_name}} {{element.last_name}}</div>
                    <div class="sub-head">{{element.email}}</div>
                  </div>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="company_name">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.COMPANY"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex">
                  <div class="profile-img me-2" [appBackgroundImg]="element.company_logo" [iType]="'company_logo'">
                  </div>
                  <div class="main-head">{{element.company_name}} </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="job_name">
              <th mat-header-cell *matHeaderCellDef>{{"COMMON.TITLE"|translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.j_n}} </td>
            </ng-container>
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef class="">{{"Address"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="hide-lines-2 add-head"> {{element.add}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef class="data-b"> {{"COMMON.CATEGORY"|translate}}</th>
              <td mat-cell *matCellDef="let element" class="data-b">
                <div class="text-semibold">{{element.j_c }}</div>
                <div>{{element.j_sc}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef class="data-b">
                {{"RECRUITER.ADDSHIFT.STARTTIME"|translate}}-{{"RECRUITER.ADDSHIFT.ENDTIME"|translate}}</th>
              <td mat-cell *matCellDef="let element" class="data-b"> {{element.st_ti}} - {{element.ed_ti}} </td>
            </ng-container>
            <ng-container matColumnDef="charges">
              <th mat-header-cell *matHeaderCellDef class="data-b"> {{"COMMON.CHARGES"|translate}}(€)</th>
              <td mat-cell *matCellDef="let element" class="data-b"> {{element.new_wages}} </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.STATUS"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="text-bold st-box  d-flex ">
                  <span class="active badge-c d-box" *ngIf="element.app==1">{{"Accepted"|translate}}</span>
                  <span class="pending badge-c d-box" *ngIf="element.app==2">{{"Pending"|translate}}</span>
                  <span class="un-attend   badge-c d-box" *ngIf="element.app==0">{{"Rejected"|translate}}</span>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>{{"COMMON.ACTION"|translate}}</th>
              <!-- <td mat-cell *matCellDef="let element"></td> -->
              <!-- <td mat-cell *matCellDef="let element">
                <i class="material-icons cursor-pointer more-ic" [matMenuTriggerFor]="menu">more_vert</i>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item color="primary" *ngFor="let item of employeeStatus"
                    (click)="onChangeEmpSt(element,item.value,element.st_dt)">
                    <span>{{item.name}}</span>
                  </button>
                  <button mat-menu-item color="primary" (click)="onAddComments(element)">
                    <span>Add Comments</span>
                  </button>
                </mat-menu>
              </td> -->
              <td mat-cell *matCellDef="let element">
                <div class="d-flex">
                  <div class="status-box accept me-2" matTooltip="{{ 'BUTTON.ACCEPT' | translate }}"
                    [ngClass]="{ opacity: element.app == '1' }" (click)="confirmationAlert(element, 'status', 'yes')">
                    <img src="assets/images/icons/tick_correct.svg" class="img-fluid" alt="" />
                  </div>
                  <div class="status-box reject" matTooltip="{{ 'BUTTON.REJECT' | translate }}"
                    [ngClass]="{ opacity: element.app == '0' }" (click)="confirmationAlert(element, 'status', 'no')">
                    <img src="assets/images/icons/cancel.svg" class="img-fluid" alt="" />
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div class="mat-table__message" *ngIf="dataSource.data.length==0">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
        </div>
        <!-- <div class="pagination-cont" *ngIf="dataSource.data.length!=0">
        <div class="show-item">
          {{"COMMON.SIP" | translate}}
          <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
            [(ngModel)]="config.itemsPerPage">
            <option [value]="item" *ngFor="let item of pageSizeOptions">
              {{ item }}
            </option>
          </select>
        </div>
        <div class="page-c">
          <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
            [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
        </div>
      </div> -->
      </div>
      <div *ngIf="currentTab == 'not_working_emp'">
        <div class="table-container flex-grow-1 ">
          <table class="" mat-table [dataSource]="dataSourceNotClock" class="mat-elevation-z8"
            *ngIf="dataSourceNotClock.data.length!=0">
            <ng-container matColumnDef="first_name">
              <th mat-header-cell *matHeaderCellDef> {{"RECRUITER.EMPLOYEE"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex cursor-pointer">
                  <div class="profile-img me-2 view-employee" [appBackgroundImg]="element.profile_picture"
                    (click)="onViewEmployee(element.em_i)"></div>
                  <div class="view-employee" (click)="onViewEmployee(element.em_i)">
                    <div class="main-head">{{element.first_name}} {{element.last_name}}</div>
                    <div class="sub-head">{{element.email}}</div>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="company_name">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.COMPANY"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex">
                  <div class="profile-img me-2" [appBackgroundImg]="element.company_logo" [iType]="'company_logo'">
                  </div>
                  <div class="main-head">{{element.company_name}} </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="job_name">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.TITLE"|translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.j_n }} </td>
            </ng-container>
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef>{{"Address"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="hide-lines-2 add-head"> {{element.add}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef class="data-b"> {{"COMMON.CATEGORY"|translate}}</th>
              <td mat-cell *matCellDef="let element" class="data-b">
                <div class="text-semibold">{{element.j_c}}</div>
                <div>{{element.j_sc }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef class="data-b">
                {{"RECRUITER.ADDSHIFT.STARTTIME"|translate}} - {{"RECRUITER.ADDSHIFT.ENDTIME"|translate}}</th>
              <td mat-cell *matCellDef="let element" class="data-b"> {{element.c_st_ti}} - {{element.c_ed_ti }} </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.STATUS"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="text-bold st-box  d-flex ">
                  <span class="un-attend   badge-c d-box" *ngIf="element.em_st==0">Absent</span>
                  <span class="pending badge-c d-box" *ngIf="element.em_st==1">Early</span>
                  <span class="pending badge-c d-box" *ngIf="element.em_st==2">Late</span>
                  <span class="un-attend badge-c d-box" *ngIf="element.em_st==3">Sick</span>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>{{"COMMON.ACTION"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <i class="material-icons cursor-pointer more-ic" [matMenuTriggerFor]="menu">more_vert</i>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item color="primary" *ngFor="let item of employeeStatus"
                    (click)="onChangeEmpSt(element,item.value,element.st_dt)">
                    <!-- <mat-icon class="kt-margin-r-0">create</mat-icon> -->
                    <span>{{item.name}}</span>
                  </button>
                  <button mat-menu-item color="primary" (click)="onAddComments(element)">
                    <!-- <mat-icon class="kt-margin-r-0">create</mat-icon> -->
                    <span>Add Comments</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div class="mat-table__message" *ngIf="dataSourceNotClock.data.length==0">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #unsassingedShift>
</ng-template>
<!-- Template selection box -->
<div id="template-box" class="wbox" [ngStyle]="{'top': positionStyles.top, 'left': positionStyles.left}">
  <div class="template-container">
    <div class="text-end primary-color text-semibold">
      <span class="me-1">+</span> Add Template
    </div>
    <div class="mt-3 mb-2">
      <input type="text" placeholder="Search Template" class="form-control w-100">
    </div>
    <div class="tem-item-c">
      <div class="tem-box " *ngFor="let item of templateArr" (click)="onAddTemplate(item)">
        <div>{{item.st_ti}}-{{item.ed_ti}}</div>
        <div>{{item.j_n}}</div>
      </div>
      <!-- <div class="tem-box">
        <div>12:00 - 5:00</div>
        <div>Morning Shift[sample]</div>
      </div>
      <div class="tem-box">
        <div>12:00 - 5:00</div>
        <div>Morning Shift[sample]</div>
      </div> -->
    </div>
  </div>
</div>
<!-- show more week view box -->
<div id="show-more" class="show-more-box wbox" [ngStyle]="{'top': positionStyles.top, 'left': positionStyles.left}">
  <div class="d-flex align-items-center justify-content-between m-box">
    <div class="v-i" (click)="onDuplicate(1)">
      <i class="material-icons me-2">content_copy</i>
      <div class="v-c">Duplicate</div>
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-between m-box">
    <div class="v-i" (click)="onAddMultiDup()">
      <i class="material-icons me-2">library_books</i>
      <div class="v-c">Multi Duplicate </div>
    </div>
    <div class="d-flex cursor-pointer">
      <i class="material-icons ms-2">keyboard_arrow_right</i>
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-between m-box">
    <div class="v-i">
      <i class="material-icons me-2">do_not_disturb_alt</i>
      <div class="v-c">Unassign</div>
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-between m-box">
    <div class="v-i" (click)="onDeleteShift()">
      <i class="material-icons me-2">delete_forever</i>
      <div class="v-c">Delete</div>
    </div>
  </div>
</div>
<!-- Job Item Container -->
<ng-template #jobItem let-event="event" let-day="day" let-unassign="unassign">
  <div class="job-item week-job-item"
    *ngIf="(!event.op_s && !unassign && event.op_n==1)|| (viewBy=='company' && !unassign && event.op_n==1)"
    [ngClass]="getShiftColor(event)" (click)="onAddShift('edit',event,day)" (mouseover)="onHover($event,'',event)"
    (mouseout)="onHoverOut()">
    <!-- <div *ngIf="filterViewWeek(sval,event) && !event.op_s" class="job-item week-job-item"
      [ngClass]="getShiftColor(event)" (click)="onAddShift('edit',event,day)"> -->
    <div class="d-flex align-items-center justify-content-between position-relative">
      <div class="text-medium" *ngIf="!event.all_day">{{getTrimmedTime(event.st_ti)}}-{{getTrimmedTime(event.ed_ti)}}
      </div>
      <div class="text-medium" *ngIf="event.all_day"> All day</div>
      <div> <i class="material-icons more-ic set-more-ic  position-absolute"
          (click)="onCoppyShift(event); $event.stopPropagation()">content_copy</i> </div>
      <!-- show the opn shift in the company name also if it is viewBy company -->
      <span class="qty qty-w ms-2" [matTooltip]="event.qty+' open spots left in this shift'">{{event.qty}}</span>
    </div>
    <div class="pt-1 text-medium clamp-line-1" *ngIf="viewBy=='user'||viewBy=='location'||viewBy=='company'"> {{
      getTrimmedTitle(event.j_sc) }} </div>
    <div class="pt-1 clamp-line-1" *ngIf="(viewBy=='company'||viewBy=='location') && event.first_name">
      ({{event.first_name}} {{event.last_name}})</div>
    <div class="pt-1 clamp-line-1" *ngIf="viewBy=='user'">({{getTrimmedTitle(event.company_name)}})</div>
    <div class="pt-1" *ngIf="viewBy=='c_user'">{{getTrimmedTitle(event.j_sc) }}</div>
    <div class="pt-1 clamp-line-1" *ngIf="viewBy=='category'||viewBy=='c_category'">{{event.first_name}}
      {{event.last_name}} </div>
    <!-- if it is open shift then don't show the tasks as tasks will only come into picture when dealing with the user wise shifts -->
    <div class="d-flex align-items-center" *ngIf="(event.tot_task!=0)&& (event.op_s!=1)">
      <mat-progress-bar mode="determinate" class="progress-m progress-round  progress-shadow"
        [value]="getTaskPercentage(event)"></mat-progress-bar>
      <div style="font-size: 12px;">{{event.tot_att}}/{{event.tot_task}}</div>
    </div>
  </div>
  <div class="job-item week-job-item open-shift" *ngIf="event.op_s && unassign" (click)="onAddShift('edit',event,day)"
    (mouseover)="onHover($event,'',event)" (mouseout)="onHoverOut()">
    <div class="d-flex align-items-center justify-content-between">
      <div class="text-medium" *ngIf="!event.all_day"> {{getTrimmedTime(event.st_ti)}} - {{getTrimmedTime(event.ed_ti)}}
      </div>
      <div class="text-medium" *ngIf="event.all_day"> All day</div>
      <div (click)="onMoreClick($event,event)" (mouseout)="onWeekHoverOut()">
        <i class="material-icons more-ic">more_vert</i>
      </div>
    </div>
    <div class="pt-1"> {{getTrimmedTitle(event.j_n) }}
      <span class="qty qty-w ms-2" [matTooltip]="event.op_val+' open spots left in this shift'">{{event.op_val}}</span>
    </div>
  </div>
</ng-template>

<!-- <ngx-spinner type="ball-scale-multiple" [fullScreen]="false"></ngx-spinner> -->
<!-- <app-loading-spinner></app-loading-spinner> -->
<div *ngIf="isLoading" class="spinner-overlay">
  <div class="ball-scale-multiple">
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
  </div>
</div>